import React, {useState, useMemo} from 'react';
import {useTranslations, useMessages, useLocale} from 'next-intl';
import {Grid, Row, Col} from '@/grid';
import {SectionPadding} from '@/section';
import Container from '@/container';
import Link from '@/links';
import {getPlanPrices} from '@/ui/plan-prices/currency/USD';
import {withMarginBottomZeroToLg} from '@/hocs/withSpacing';
import {H3} from '@/typography';
import Plan from './plan';

// Styles
import styles from './styles.module.scss';

const CtaDefaultMarginedMob = withMarginBottomZeroToLg(Link);

const PlansSection = () => {
  const t = useTranslations('pricing.plansSection.note');
  const sharedT = useTranslations('shared');
  const messages = useMessages();
  const locale = useLocale();

  // Get locale-aware plan prices
  const PLAN_PRICES = useMemo(() => getPlanPrices(messages, locale), [messages, locale]);

  const planKeys = Object.keys(PLAN_PRICES);
  const companySizeList = Object.keys(PLAN_PRICES.standard.prices);
  const [companySize, setCompanySize] = useState(companySizeList[0]);
  const [isHREnabled, setIsHREnabled] = useState(false);
  const [isRecruitingEnabled, setIsRecruitingEnabled] = useState(true);

  const showDemoTeamSizes = companySizeList;
  showDemoTeamSizes.splice(0, 2);

  const onCompanySizeChange = item => setCompanySize(item?.value);

  return (
    <div className={styles['plans-section']}>
      <Container>
        <div data-testid="plans-columns" className={styles['plans-section__inner']}>
          <Grid className={styles['plans-section__inner-top']}>
            <Row className={styles['plans-grid']}>
              {planKeys.map(planKey => (
                <Col
                  xs={12}
                  lg={4}
                  className={styles['plans-grid__col']}
                  key={`plan_${PLAN_PRICES[planKey].name}`}>
                  <Plan
                    plan={PLAN_PRICES[planKey]}
                    {...{
                      companySize,
                      onCompanySizeChange,
                      isHREnabled,
                      isRecruitingEnabled,
                      setIsHREnabled,
                      setIsRecruitingEnabled
                    }}
                  />
                </Col>
              ))}
            </Row>
          </Grid>
        </div>
      </Container>
   
    <SectionPadding>
      <Grid>
          <Row center="xs">
            <Col xs={12}>
              <div className={styles['plans-section__note']}>
                <H3>{t('title')}</H3>
                <p>{t('description')}</p>
              </div>
            </Col>

            <Col xs={12}>
              <ul className={styles['list-inline-to-bl']}>
                <li>
                  <CtaDefaultMarginedMob
                    href="/free-trial"
                    variant="cta-default-xs"
                    customAttributes={{
                      'data-gtm': 'pricing-body-free-trial-btn',
                      'data-ui': 'pricing-body-free-trial'
                    }}>
                    {sharedT('freeTrialCTALabel')}
                  </CtaDefaultMarginedMob>
                </li>
                <li>
                  <Link
                    href="/demo"
                    variant="primary"
                    customAttributes={{
                      'data-gtm': 'pricing-body-demo',
                      'data-ui': 'pricing-body-demo'
                    }}>
                    {sharedT('demoCTALabel')}
                  </Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Grid>
        </SectionPadding>
        </div>
  );
};

export default PlansSection;
